import * as React from "react";
const SvgCheck = (props) => (
  <svg
    width={62}
    height={62}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <g filter="url(#Check_svg__a)">
      <path
        d="M9 26C9 13.85 18.85 4 31 4s22 9.85 22 22-9.85 22-22 22S9 38.15 9 26Z"
        fill="#F4F4F4"
      />
      <path
        d="M28.53 33a1.429 1.429 0 0 1-1.013-.419l-6.079-6.08a1.435 1.435 0 0 1-.019-2.044 1.433 1.433 0 0 1 2.044.016l5.066 5.066 9.122-9.119a1.433 1.433 0 1 1 2.028 2.027L29.544 32.58A1.429 1.429 0 0 1 28.53 33Z"
        fill="#622FEE"
      />
      <path
        d="M31 46c-11.046 0-20-8.954-20-20H7c0 13.255 10.745 24 24 24v-4Zm20-20c0 11.046-8.954 20-20 20v4c13.255 0 24-10.745 24-24h-4ZM31 6c11.046 0 20 8.954 20 20h4C55 12.745 44.255 2 31 2v4Zm0-4C17.745 2 7 12.745 7 26h4c0-11.046 8.954-20 20-20V2Z"
        fill="#fff"
      />
    </g>
    <defs>
      <filter
        id="Check_svg__a"
        x={0}
        y={0}
        width={62}
        height={62}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={5} />
        <feGaussianBlur stdDeviation={4.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5387_2737"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5387_2737"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgCheck;
